import { getCookie } from "./getCookie";

export interface FileUploadResponse {
    success: boolean;
    message: string;
    data: {
        fileId: string;
        originalName: string;
        fileName: string;
        mimeType: string;
        extension: string;
        size: number;
        compressedSize: number;
        isCompressed: boolean;
        path: string;
        url: string;
        category: string;
        status: string;
        source: string;
        description: string;
        tags: string[];
        folder: string;
        entityType: string;
        entityId: string;
        _id: string;
        createdAt: string;
        updatedAt: string;
        imageMetadata?: {
            width: number;
            height: number;
            thumbnailPath: string;
            thumbnailUrl: string;
        };
    };
}

export const uploadFile = async (
    file: File,
    options: {
        description?: string;
        folder?: string;
        entityType?: string;
        entityId?: string;
    } = {}
): Promise<FileUploadResponse> => {
    const uploadUrl = process.env.REACT_APP_FILE_UPLOAD_URL || "https://files.salar.in/api/v1/files/upload";
    const accessToken = getCookie("access_token");

    if (!accessToken) {
        throw new Error("No access token found. Please log in.");
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("description", options.description || "");
    formData.append("folder", options.folder || "");
    formData.append("entityType", options.entityType || "");
    formData.append("entityId", options.entityId || "");

    const response = await fetch(uploadUrl, {
        method: "POST",
        headers: {
            "accept": "*/*",
            "x-api-key": accessToken,
        },
        body: formData,
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Upload failed with status ${response.status}`);
    }

    return response.json();
};
